import WithDirection from '@app/settings/withDirection';
import { Progress } from 'antd';
import AntProgress from './styles/progress.style';

const WDProgress = AntProgress(Progress);

export const IsoProgress = WithDirection(WDProgress);
